import { render } from "./ResumeOrder.vue?vue&type=template&id=0564b4aa"
import script from "./ResumeOrder.vue?vue&type=script&lang=js"
export * from "./ResumeOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__